<template lang="pug">
	.app-core--range-filter
		EditableLabel
			.font-small.upper.grey.value(:class="{ active: textValue !== this.$tCaption('all') }") {{title}}: {{textValue}}
			template(slot="editor")
				.flex-col.field(:style="{ width: width }")
					.title.font-small.upper.grey(v-if="title") {{title}}
					template(v-if="minMaxSpecified")
						DxRangeSlider(:value="currentValue", @valueChanged="v => onValueChange({ start: v.value[0], end: v.value[1] })", :min="minValue", :max="maxValue", :step="source && source.length ? 1 : step")
						.flex-row.justify(v-if="leftText || rightText")
							.left
								span {{leftText()}}
							.right
								span {{rightText()}}
					template(v-else)
						.flex-row.justify.space.align-center
							DxNumberBox(:value="currentValue[0]", @valueChanged="v => onValueChange({ start: v.value })")
							span -
							DxNumberBox(:value="currentValue[1]", @valueChanged="v => onValueChange({ end: v.value })")
</template>

<script>
	import VueTypes from 'vue-types';
	import { DxRangeSlider } from 'devextreme-vue/range-slider';
	import { DxNumberBox } from 'devextreme-vue/number-box';
	import EditableLabel from 'app-core/EditableLabel.vue';

	export default {
		components: {DxRangeSlider, DxNumberBox, EditableLabel},
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			title: VueTypes.string.def(null),
			value: VueTypes.any.def(null),
			min: VueTypes.number.def(null),
			max: VueTypes.number.def(null),
			source: VueTypes.array.def(null),
			nameField: VueTypes.string.def('name'),
			width: VueTypes.any.def(null),
			textResolver: Function,
			step: VueTypes.number.def(null)
		},
		data() {
			return {};
		},
		computed: {
			minValue() {
				return this.source && this.source.length ? 0 : this.min;
			},
			maxValue() {
				return this.source && this.source.length ? this.source.length - 1 : this.max;
			},
			minMaxSpecified() {
				return (this.source && this.source.length) || (this.min !== this.max);
			},
			currentValue() {
				return this.value || (this.minMaxSpecified ? [this.minValue, this.maxValue] : []);
			},
			textValue() {
				if (this.minMaxSpecified && (this.currentValue[0] != this.minValue || this.currentValue[1] != this.maxValue)) {
					return `${this.leftText()}-${this.rightText()}`;
				}
				return this.$tCaption('all');
			}
		},
		methods: {
			onValueChange(vals) {
				const val = this.currentValue;
				if (vals.hasOwnProperty('start'))
					val[0] = vals.start;
				if (vals.hasOwnProperty('end'))
					val[1] = vals.end;

				if (__DEBUG__)
					console.info(`Value changed for ${this.title}`, { val, source: this });
				this.$emit('change', val);
				this.$forceUpdate();
			},
			leftText() {
				if (this.textResolver)
					return this.textResolver(this, 'left', this.currentValue);
				return this.source && this.source.length ? this.source[this.currentValue[0]][this.nameField] : this.currentValue[0];
			},
			rightText() {
				if (this.textResolver)
					return this.textResolver(this, 'right', this.currentValue);
				return this.source && this.source.length ? this.source[this.currentValue[1]][this.nameField] : this.currentValue[1];
			}
		}
	};
</script>
<style lang='scss'>
	.app-core--range-filter{
		.value.active {
			font-weight: 600;
		}
	}
</style>
